import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { ROLE, checkRole } from '@common/components/RBAC';
import { getRoute } from '@common/constants/CampusRoutes';

import useId from '@common/helpers/useId';
import useModel from '@common/helpers/useModel';
import StudentLesson, { IStudentLessonModel } from '@common/models/StudentLessons/Studentlesson';

import store from 'store';

export default () => {
	const navigate = useNavigate();
	const location = useLocation();

	const { programId, groupId, programGroupId, scheduleLessonId } = useId([
		'programId',
		'groupId',
		'programGroupId',
		'scheduleLessonId',
	]);
	const isParent = checkRole(ROLE.PARENT);

	const lessonModel = useModel(
		StudentLesson,
		{
			schedule_lesson_id: scheduleLessonId,
			...(isParent && store.currentStudentId ? { student_id: store.currentStudentId } : {}),
		},
		[scheduleLessonId, store.currentStudentId],
		{
			disableFetch: true,
		},
	) as IStudentLessonModel;

	useEffect(() => {
		const fetch = async () => {
			try {
				if (programGroupId) {
					await lessonModel.fetch();
				} else {
					await lessonModel.fetchIndiv({
						student_id: store.currentStudentId,
					});
				}
			} catch (e) {
				console.error(e);
				lessonModel.setLessonStartDate(e?.data?.start);
			}
		};

		fetch();
	}, [lessonModel, programGroupId, scheduleLessonId]);

	const goBack = () => {
		if (location.key !== 'default') {
			navigate(-1);
		} else {
			navigate(getRoute(['PROGRAMS'], programId, groupId, programGroupId));
		}
	};

	return { lessonModel, goBack };
};
